export default {
	mortgage_quotation: {
		en: "Mortgage Quotation",
		ar: "طلب أسعار رهن العقار",
	},
	mortgage_amount: {
		en: "Mortgage Amount",
		ar: "مبلغ الرهن العقاري",
	},
	select_bank: {
		en: "Select The Bank",
		ar: "اختر البنك",
	},
	mortgage_submit: {
		en: "Thank you for submitting your request.",
		ar: "شكرا لك على تقديم طلبك.",
	},
	number_of_years: {
		en: "Number of Years",
		ar: "عدد السنوات",
	},
	monthly_income: {
		en: "Monthly Income (AED)",
		ar: "الدخل الشهري (درهم)",
	},
	income_10k: {
		en: "10,000 to 50,000",
		ar: "10,000 إلى 50,000",
	},
	income_50k: {
		en: "50,000 to 100,000",
		ar: "50,000 إلى 100,000",
	},
	income_100k: {
		en: "100,000 and above",
		ar: " 100,000 وما فوق",
	},
	mortgage_info: {
		en: "All further communication from your selected bank will be through below listed email address and / or phone number which is registered with Dubai Land Department. Please modify in case you wish to update your communication details for this service only.",
		ar: "سيتم التواصل معكم من قبل البنك بواسطة رقم الجوال \\ البريد الإلكتروني المسجل لدى دائرة الأراضي و الأملاك بدبي. الرجاء تحديث بيانات الاتصال في حال أردتم تغيير بيانات اتصالكم المتعلق بهذه الخدمة",
	},
	mortgage_title_deed: {
		en: "I agree that Dubai Land Department will be sharing the selected property's Title deed information to the selected Bank(s).",
		ar: "أوافق على إعطاء دائرة الأراضي و الأملاك بدبي الصلاحية لمشاركة معلومات ملكية هذا العقار مع البنوك التي اخترتها",
	},
	add_bank_error: {
		en: "Please add at least one bank to submit.",
		ar: "الرجاء إضافة بنك واحد على الأقل.",
	},
	trust_account_number: {
		en: "Trust Account Number",
		ar: "رقم حساب الثقة ",
	},
	bank_name: {
		en: "Bank Name",
		ar: "اسم البنك",
	},
	tenure: {
		en: "Tenure",
		ar: "الفترة",
	},
	years: {
		en: "Years",
		ar: "السنوات",
	},
	mortgage_quotation_details: {
		en: "Mortgage Quotation Details",
		ar: "تفاصيل طلب أسعار رهن العقار",
	},
	add_bank: {
		en: "Add Bank/s",
		ar: "إضافة بنك",
	},
	no_bank_added: {
		en: "No banks have been added yet. Please click \"Add Bank/s\" to add.",
		ar: "لا يوجد بنوك مضافة. من فضلك اضغط على \" اضافة بنك \" للاضافة",
	},
	search_bank: {
		en: "Search Bank",
		ar: "البحث عن البنك",
	},
	max_banks_added: {
		en: "Maximum 3 banks can be added.",
		ar: "الحد الأقصى لعدد البنوك المضافة هوا ثلاثة فقط.",
	}
};
